import { graphql } from "gql";

const TAG_QUERY = graphql(`
  query Tag($id: [ID!]!) {
    tags: tag(id: $id) {
      ...Tag
    }
  }
`);

export default TAG_QUERY;
